// extracted by mini-css-extract-plugin
export default {"container":"AddPost_container__sl4ok","imgContainer":"AddPost_imgContainer__JZUup","createPostContainer":"AddPost_createPostContainer__kZhks"};